import { applications, ChargebeeAppConfig } from "@sciam/chargebee/constants.json";

export const appsBySlug: Record<string, ChargebeeAppConfig> = Object.fromEntries(
  applications.map((app) => [app.slug, app]),
);

export const defaultAppSlug: string = import.meta.env.PUBLIC_CHARGEBEE_APP || "prod";
export const defaultSiteId = appsBySlug[defaultAppSlug].siteId || "sciam-prod";
